package org.matthewo.pages.event.tabs

import js.objects.buildReadonlyRecord
import org.matthewo.GAME_SPECIFIC_SEARCH
import org.matthewo.api.*
import org.matthewo.pages.event.EventTabFC
import org.matthewo.pages.team.tabs.toTeam
import org.matthewo.plots.MetricComparisonScatterPlot
import org.matthewo.router.contains
import org.matthewo.routes.API
import react.useMemo
import tanstack.react.router.useNavigate
import tanstack.react.router.useSearch

private val GAME_SPECIFIC_CONFIGS = mapOf(
    2021 to GameSpecificStatsConfig(
        "Teleop Hub Total",
        "Teleop Alliance",
        { stats: FreightFrenzyStats -> stats.alliance },
        "Teleop Shared",
        { stats: FreightFrenzyStats -> stats.shared },
    ),
    2024 to GameSpecificStatsConfig(
        "Total",
        "Sample", { stats: IntoTheDeepStats -> stats.sample },
        "Specimen", { stats: IntoTheDeepStats -> stats.specimen },
    ),
    102024 to GameSpecificStatsConfig(
        "Total",
        "Sample", { stats: IntoTheDeepCRIStats -> stats.sample },
        "Specimen", { stats: IntoTheDeepCRIStats -> stats.specimen }
    ),
)

private data class GameSpecificStatsConfig<T : GameSpecificStats>(
    val sumMetricTitle: String,
    val xMetricTitle: String,
    val xMetric: (T) -> Double,
    val yMetricTitle: String,
    val yMetric: (T) -> Double,
)

val EventTeamsPeriodsScatterPlot = EventTabFC<API.Event.Stats, List<EventCompetitionSimple>>({ event, _, query ->
    API.Event.Stats(event, "pre" in query)
}) { (coroutineScope, year, eventCode, data) ->
    val searchParams = useSearch()
    val navigate = useNavigate()

    val gameSpecific = useMemo(searchParams) { GAME_SPECIFIC_SEARCH in searchParams }

    MetricComparisonScatterPlot {
        this.data = data ?: []
        val config = GAME_SPECIFIC_CONFIGS[year]
        if (!gameSpecific || null == config) {
            sumMetricTitle = "NP Total"
            xMetricTitle = "Teleop"
            xMetric = { competition: EventCompetitionSimple -> competition.teleopOpr }
            yMetricTitle = "Auto + Endgame"
            yMetric = { competition: EventCompetitionSimple -> competition.autoOpr + competition.endgameOpr }
        } else {
            sumMetricTitle = config.sumMetricTitle
            xMetricTitle = config.xMetricTitle
            xMetric = { competition: EventCompetitionSimple -> config.xMetric(competition.gameSpecific.asDynamic()) }
            yMetricTitle = config.yMetricTitle
            yMetric = { competition: EventCompetitionSimple -> config.yMetric(competition.gameSpecific.asDynamic()) }
        }
        pointLabel = { competition: EventCompetitionSimple -> "${competition.number}" }
        tooltipLabel = { competition: EventCompetitionSimple -> "${competition.number} - ${competition.name}" }
        lookup = { competition: EventCompetitionSimple -> competition.number }
        onClick = { competition: EventCompetitionSimple ->
            navigate {
                toTeam(teamNumber = competition.number, eventCode = eventCode)
            }
        }
        onToggle = {
            navigate {
                search = buildReadonlyRecord {
                    if (!gameSpecific && year in GAME_SPECIFIC_CONFIGS) this[GAME_SPECIFIC_SEARCH] = Unit
                }
                replace = true
            }
        }
        onlyShowTopLabels = false
    }
}
